import { UpdateActionRequest } from './api/action-api.model';
import { UpdateActionValue } from './actions.model';

/** Maps editor values to AIM's PATCH /action/{actionId} contract. */
export function buildActionUpdateRequest(
  value: UpdateActionValue,
): UpdateActionRequest {
  return {
    ...(value.title !== undefined ? { name: value.title.trim() } : {}),
    ...(value.description !== undefined
      ? { description: value.description?.trim() || '' }
      : {}),
    ...(value.actionTypeCode !== undefined
      ? { actionTypeCode: value.actionTypeCode }
      : {}),
    ...(value.assignedToId !== undefined
      ? { assignedToId: value.assignedToId }
      : {}),
    ...(value.statusCode !== undefined ? { statusCode: value.statusCode } : {}),
    ...(value.dueDate !== undefined ? { dueDate: value.dueDate } : {}),
    ...(value.priorityCode !== undefined
      ? { priorityCode: value.priorityCode }
      : {}),
    ...(value.communicationPreferenceCode !== undefined
      ? { communicationPreferenceCode: value.communicationPreferenceCode }
      : {}),
    ...(value.clientPromise !== undefined
      ? { clientPromise: value.clientPromise }
      : {}),
  };
}
